export type CrmTab = 'customers' | 'discounts' | 'campaigns' | 'feedback' | 'recipients';

export const CRM_TABS: CrmTab[] = ['customers', 'feedback', 'discounts', 'campaigns', 'recipients'];

export const CRM_TAB_LABELS: Record<CrmTab, string> = {
  customers: 'Guests',
  feedback: 'Feedback',
  discounts: 'Discounts',
  campaigns: 'Campaigns',
  recipients: 'Recipients',
};

export const CRM_TAB_SUBTITLES: Record<CrmTab, string> = {
  customers: 'Guest records and loyalty',
  feedback: 'Guest messages and ratings',
  discounts: 'Offers and promo codes',
  campaigns: 'Email campaigns',
  recipients: 'Who receives CRM notifications',
};

export const isCrmTab = (value: string | undefined): value is CrmTab => (
  !!value && (CRM_TABS as string[]).includes(value)
);
